import { onboardingRoutePrefix } from '@provider-portal/common/routing/routes';
import { Link as RouterLink } from 'react-router-dom';
import { ArrowBackward } from '@bolteu/kalep-react-icons/dist';
import { IconButton } from '@provider-portal/design-common/kalep/components/IconButton/IconButton';
import { useIsProviderInSSUFlow } from '@provider-portal/common/hooks/useIsProviderInSSUFlow';
import { Box } from '@provider-portal/design-common/kalep/components/Box/Box';
import { useIsOnboardingRoute } from '@provider-portal/common/routing/hooks';

export function ReturnToOnboardingLink() {
  const isProviderInSSUFlow = useIsProviderInSSUFlow();
  const isOnboardingRoute = useIsOnboardingRoute();

  if (!isProviderInSSUFlow) {
    return null;
  }

  if (isOnboardingRoute) {
    return null;
  }

  return (
    <RouterLink to={onboardingRoutePrefix}>
      <Box mb="16px" mt="4px">
        <IconButton size="large" color="secondary">
          <ArrowBackward />
        </IconButton>
      </Box>
    </RouterLink>
  );
}
